import { useEffect } from "react";

/**
 * GTranslate footer widget. Injects the official GTranslate settings and script
 * once, then renders the wrapper div. Safe against React double-mount in dev.
 */
export function FooterGTranslate() {
  useEffect(() => {
    // Settings must exist on window before dwf.js runs
    (window as any).gtranslateSettings = {
      default_language: "es",
      native_language_names: true,
      detect_browser_language: true,
      wrapper_selector: ".gtranslate_wrapper",
      flag_size: 24,
      switcher_horizontal_position: "inline",
      alt_flags: { en: "usa" },
    };

    const SRC = "https://cdn.gtranslate.net/widgets/latest/dwf.js";
    let script = document.querySelector<HTMLScriptElement>(
      `script[src="${SRC}"]`
    );
    if (!script) {
      script = document.createElement("script");
      script.src = SRC;
      script.defer = true;
      document.body.appendChild(script);
    }
  }, []);

  return (
    <div className="mt-6 flex justify-center">
      <div className="gtranslate_wrapper" />
    </div>
  );
}

export default FooterGTranslate;
